import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { register } from "../services/users";

function RegistrationForm() {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isMaster, setIsMaster] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(""); // Reset errore precedente
    try {
      await register(email, username, password, isMaster);
      navigate("/login");
    } catch (error) {
      // L'errore ora è un oggetto { status, message, data }
      setError(error.message || "Errore durante la registrazione");
    }
  };

  return (
    <div className="registration-form">
      <form onSubmit={handleRegister}>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            id="email"
            type="email"
            value={email}
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="username">Username:</label>
          <input
            id="username"
            type="text"
            value={username}
            autoComplete="username"
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            id="password"
            type="password"
            value={password}
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="isMaster">Master User</label>
          <input
            id="isMaster"
            type="checkbox"
            checked={isMaster}
            onChange={(e) => setIsMaster(e.target.checked)}
          />
        </div>
        <button type="submit">Registrati</button>
        {error && <p>{error}</p>}
        <div>
          <Link to="/forgot-password">Recupera password</Link>
          <Link to="/login">Vai a Login</Link>
        </div>
      </form>
    </div>
  );
}

export default RegistrationForm;
